/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */
import * as firebase from 'firebase/app';

export async function sendExamResult(examId, result) {
  const db = firebase.firestore();
  await db.collection('exams').doc(examId).set({ result });
}

export async function getExams() {
  const db = firebase.firestore();

  // Get list of exams.
  const exams = [];
  const examsDocs = await (await db.collection('exams').get()).docs;
  const promisesExams = examsDocs.map(async (docExam) => {
    // Get list of samples from this exam.
    const samples = [];
    const samplesDocs = await (await db.collection('exams').doc(docExam.id).collection('samples').get()).docs;
    const promisesSamples = samplesDocs.map(async (docSample) => {
      const sample = docSample.data();
      samples.push(sample);
    });
    // Wait for all samples.
    await Promise.all(promisesSamples);

    const exam = docExam.data();
    exams.push({
      id: docExam.id,
      ...exam,
      samples,
    });
  });
  // Wait for all exams (and samples).
  await Promise.all(promisesExams);
  return exams;
}

// Get the more accurate location from list of samples.
export function getExamLocation(samples) {
  // Initial accuracy value;
  let position = {
    accuracy: -1,
  };

  samples.forEach((sample) => {
    // Copy position if accuracy is better (lower) than the saved one.
    if (sample.position) {
      if (position.accuracy < 0 || sample.position.accuracy < position.accuracy) {
        position = sample.position;
      }
    }
  });
  return position;
}
